import { getResponsiveProp } from '..';
import { rem, responsive } from '../helpers';

function toBoxShadow(shadow, color) {
  return "".concat(shadow.map(rem).join(' '), " ").concat(color);
}

function shadowStyle(shadow) {
  if (!shadow) return {};
  var outline = "0 0 0 ".concat(rem(1), " var(--card-shadow-outline-color)");
  var umbra = toBoxShadow(shadow.umbra, 'var(--card-shadow-umbra-color)');
  var penumbra = toBoxShadow(shadow.penumbra, 'var(--card-shadow-penumbra-color)');
  var ambient = toBoxShadow(shadow.ambient, 'var(--card-shadow-ambient-color)');
  return {
    boxShadow: "".concat(outline, ", ").concat(umbra, ", ").concat(penumbra, ", ").concat(ambient)
  };
}

export function responsiveShadowStyle(props) {
  var theme = props.theme;
  return responsive(theme.sanity.media, getResponsiveProp(props.shadow).map(function (shadowIndex) {
    return shadowStyle(theme.sanity.shadows[shadowIndex]);
  }));
}